module.exports = __webpack_public_path__ + "fonts/PressStart2P-Regular.a8b4ae57.woff2";